module.exports = __webpack_public_path__ + "static/media/KORU-logo.93c78eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/KORU-logo.png
// module id = 109
// module chunks = 0